import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify'; 
import { scaleIn } from '../../animations/modal.animation';

@Component({
  selector: 'app-navigation-modal',
  templateUrl: './navigation-modal.component.html',
  styleUrls: ['./navigation-modal.component.css'], 
  animations: [scaleIn]
})
export class NavigationModalComponent implements OnInit {

  @Input() closable = true;
  @Input() visible: boolean;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public displayReg: boolean; 
  public displayLogin: boolean; 
  public displaySponsor: boolean; 
  isHidden: boolean;
  userGroup: any;
  username: string;
  showMenu: boolean;
  @Output() closeAuthForms: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  constructor(private router: Router) { 
    this.getCurrentAuthenticatedUser();
  }

  ngOnInit() {

  }

  getCurrentAuthenticatedUser(){
    this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
		    this.username = user.attributes.name+" "+user.attributes.family_name;
        this.isHidden = false;

        this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
        // console.log('Detailed user group data ==> ', user.signInUserSession.accessToken.payload['cognito:groups'][0]); 
        // console.log('header user', user);
        
      },
      (error) =>{
        // console.log("authentication error", error); 
        
        this.isHidden = true;
      }); 
  }

  onSponsorLogin() {
    this.displaySponsor = true; 
    this.close(); 
  }

  onOwnerLogin() {
    this.displayLogin = true; 
    this.close(); 
    console.log('onWonerLogin(() called !!!')
  }

  onRegisterOwner() {
    this.displayReg = true; 
    this.close(); 
  }

  closed(event: any){
    this.closeAuthForms.emit(false);
    this.displayLogin = false;
    this.displayReg = false;
    // this.visible = false;
    // this.visibleChange.emit(this.visible);

    // this.displayLogin = false;
    // this.loginForm.reset(); 
    // this.closeLogin.emit(this.displayLogin);
  }

  close() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  goto(url: string): void {
    this.router.navigate([url]).then((completed) => {
      setTimeout(() => {
        this.close();
      }, 500);
    });
  }

  onRegister(){
    this.router.navigateByUrl('/reg-page');
  }

  signOut(){
    sessionStorage.clear();
    
    Auth.signOut({ global: true })
    .then(data => {
      this.isHidden = true;

      // console.log("Logout Data: ", data);
      this.router.navigateByUrl('/home');
      location.reload();
    })
    .catch(err => console.log('Err ::', err));

    // location.reload();
  }

}
